import { Validator } from '@vista-digital/validator';
import { defaultFilmDirectorsDisplayText, filmDirectorsDisplayTextValidator } from './display-text';
export const defaultFilmDirectorsProps = {
    displayText: defaultFilmDirectorsDisplayText
};
export const filmDirectorsPropsValidator = Validator.object({
    displayText: filmDirectorsDisplayTextValidator
});
